import React from 'react'
import PropTypes from 'prop-types'

import WidgetPage from 'components/hocs/widget-page'

import MortgageRateWidget from './widget'

const MortgageRateTableContainer = (props) => {
  const { theme = 'credible3' } = props
  // The container was added for the React ReactResizeDetector correct working
  return (
    <div>
      <MortgageRateWidget {...props} theme={theme} />
    </div>
  )
}

MortgageRateTableContainer.propTypes = {
  theme: PropTypes.string,
}

export default WidgetPage(MortgageRateTableContainer)
